import { K8sProvider } from '@cast/shared-types';

// Temporary hardcoded provider type. The endpoint requires it, but backend ignores it for castctl onboarding.
// TODO(Daniel): remove once backend makes it optional: https://castai.atlassian.net/browse/UI-6803
export const CASTCTL_PLACEHOLDER_CLUSTER_PROVIDER = K8sProvider.EKS;
